module.exports = __webpack_public_path__ + "img/star_4.90f78275.png";